import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query cliniqueEnquery {
        file(relativePath: { eq: "clinique-du-sport.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Espace Médical Vauban is located in Paris 7th arrondissement, opposite the dome of the Invalides."
        css={css`
          width: 100%;
        `}
      />
    )}
  />
)
